// extracted by mini-css-extract-plugin
export default {"root":"y1CyfGzwd0","text":"SkJdkekGzO"};